import { render, staticRenderFns } from "./CompSetting.vue?vue&type=template&id=489d9395"
import script from "./CompSetting.vue?vue&type=script&lang=js"
export * from "./CompSetting.vue?vue&type=script&lang=js"
import style0 from "./CompSetting.vue?vue&type=style&index=0&id=489d9395&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports